<template>
<div class="chapter">
<div class="inner_page">
<p class="ded2">The author wishes to thank the Texas Institute of Letters</p><p class="ded">and the University of Texas at Austin for the Dobie-Paisano Fellowship,</p><p class="ded">and the Copernicus Society of America</p><p class="ded">for the James Michener Award.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Brownsville_dedi-1.vue?51927aab